import React, { lazy } from 'react';
const bonuses = [{
  title: '4 Mentorías grupales- 1 por semanal en vivo',
  description: 'Acompañamiento real para que no te quedes trabado solo.',
  price: 'ARS 468.990',
  image: 'https://cdn.magicpatterns.com/uploads/aoUTPp9FBBEVcvSQSiumnw/Diseno_sin_titulo_(2).png'
}, {
  title: 'Prompts de IA para contenido y anuncios',
  description: 'Para acelerar ideas, copies, hooks y ejecución.',
  price: 'ARS 24.990',
  image: 'https://cdn.magicpatterns.com/uploads/eQLE1BsHgnS72AUgk4XpC8/bono_2.png'
}, {
  title: 'Checklist de lanzamiento',
  description: 'Para que no se te escape ningún paso importante.',
  price: 'ARS 34.990',
  image: 'https://cdn.magicpatterns.com/uploads/pNRpihPYxn1E9ErxUCsMHD/bono.png'
}, {
  title: 'Estructura de Landing Page',
  description: 'Para que puedas armar una página simple y funcional para vender.',
  price: 'ARS 775.000',
  image: 'https://cdn.magicpatterns.com/uploads/bDHdZ9qT59p21m84ykHJcH/bono4.png'
}, {
  title: 'Plantillas de copy para ventas',
  description: 'Para comunicar mejor tu oferta y vender con más claridad.',
  price: 'ARS 29.990',
  image: 'https://cdn.magicpatterns.com/uploads/4KUo9pNbpqkjwPfek3ezN8/bono_5.png'
}];
const TOTAL_SAVINGS_ARS = '1.333.960';
export function BonusesSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="bonos-de-regalo" className="bg-[#9C16A3] px-4 py-12 md:py-16" data-id="element-27" data-mp="gkltm8jk4pg5">
      <div className="mx-auto max-w-6xl" data-id="element-28" data-mp="lcdmipq6r79g">
        <header className="mb-12 text-center" data-id="element-29" data-mp="ldezx0uoc5uc">
          <p className="inline-flex items-center rounded-full border border-yellow-300 bg-yellow-400 px-5 py-2 text-sm font-black tracking-wide text-[#2F0240] shadow-lg md:text-base" data-id="element-30" data-mp="qb6xaae38k5x">
            BONUS DE REGALO
          </p>
          <h2 className="mt-5 text-4xl font-black leading-tight text-white md:text-5xl" data-id="element-31" data-mp="108l6boxom6o7">
            ACCEDÉ HOY Y LLEVATE LOS 5 BONOS GRATIS
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base font-medium text-purple-100 md:text-lg" data-id="element-32" data-mp="aiw70quohx3w">
            Recursos premium para acelerar tu lanzamiento, incluidos sin costo
            al ingresar a Dominando Shopify.
          </p>
        </header>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-33" data-mp="fjafga06z92g">
          {bonuses.map((bonus, index) => <article key={bonus.title} role="button" tabIndex={0} aria-label={`Ver la compra del Bono ${index + 1}: ${bonus.title}`} onClick={scrollToCompra} onKeyDown={event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            scrollToCompra();
          }
        }} className="group cursor-pointer overflow-hidden rounded-2xl border border-white/30 bg-white shadow-xl transition-transform duration-200 hover:-translate-y-1 focus:outline-none focus-visible:ring-4 focus-visible:ring-yellow-300" data-id="element-34" data-mp="ta5i34k3ktxl" data-mpi={index}>
              <div className="flex items-center justify-between bg-[#111111] px-4 py-3" data-id="element-35" data-mp="1kip6saoftbk8">
                <span className="text-xs font-black tracking-widest text-white" data-id="element-36" data-mp="15tj9is95tvez">
                  BONUS {String(index + 1).padStart(2, '0')}
                </span>
                <span className="rounded-full bg-[#22c55e] px-3 py-1 text-[11px] font-black tracking-wide text-black animate-[neon-green-glow_1.4s_ease-in-out_infinite]" data-id="element-37" data-mp="wtwagd3wl1p3">
                  HOY GRATIS
                </span>
              </div>

              <div className="flex min-h-[250px] items-center justify-center bg-[#171717] px-3 py-4" data-id="element-38" data-mp="mx197mg8wn74">
                <img src={bonus.image} alt={`Bono ${index + 1}: ${bonus.title}`} loading="lazy" className="h-auto w-full object-contain" data-id="element-39" data-mp="rv32f07dy2wb" />
              </div>

              <div className="p-6" data-id="element-40" data-mp="m62tcfyxkdk0">
                <h3 className="text-xl font-black text-gray-950" data-id="element-41" data-mp="m51jufxkbz4e">
                  Bono {index + 1} — {bonus.title}
                </h3>
                <p className="mt-2 min-h-[48px] text-sm leading-relaxed text-gray-600 md:text-base" data-id="element-42" data-mp="h5f5g3600cu0">
                  {bonus.description}
                </p>
                <div className="mt-5 flex items-center justify-between gap-3 border-t border-gray-200 pt-4" data-id="element-43" data-mp="85s2hcxmeyyu">
                  <div data-id="element-44" data-mp="391oqw9agfgl">
                    <p className="text-xs font-bold uppercase tracking-wide text-gray-500" data-id="element-45" data-mp="39jq27at5jvd">
                      Valor individual
                    </p>
                    <p className="text-lg font-black text-red-600 line-through decoration-2" data-id="element-46" data-mp="3po35m7bir53f">
                      {bonus.price}
                    </p>
                  </div>
                  <span className="rounded-lg bg-black px-3 py-2 text-sm font-black text-[#22c55e] animate-[neon-green-glow_1.4s_ease-in-out_infinite]" data-id="element-47" data-mp="3gmwnxux4vo8l">
                    HOY GRATIS
                  </span>
                </div>
              </div>
            </article>)}
        </div>

        <section aria-labelledby="ahorro-bonos-title" className="mt-10 overflow-hidden rounded-3xl border border-yellow-300/50 bg-[#0D0D0D] shadow-2xl" data-id="element-48" data-mp="1w42p6s9gnlw1">
          <div className="border-b border-white/10 px-6 py-7 text-center md:px-10" data-id="element-49" data-mp="2550qv3wffhbg">
            <p className="text-sm font-black uppercase tracking-[0.2em] text-[#22c55e]" data-id="element-50" data-mp="252wmylyj2ib6">
              Tu ahorro de hoy
            </p>
            <h3 id="ahorro-bonos-title" className="mt-2 text-2xl font-black text-white md:text-3xl" data-id="element-51" data-mp="1ddbhdv54g3jr">
              Todo esto se suma gratis a tu programa
            </h3>
            <p className="mx-auto mt-3 max-w-3xl text-sm leading-relaxed text-gray-300 md:text-base" data-id="element-52" data-mp="1m6eto0416act">
              Hoy te llevás los 5 bonos gratis con la compra del programa
              completo Dominando Shopify.
            </p>
          </div>

          <ul className="mx-auto max-w-3xl divide-y divide-white/10 px-6 py-4 text-left md:px-10" data-id="element-53" data-mp="tnhi6w02um5i">
            {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-center justify-between gap-4 py-4" data-id="element-54" data-mp="1s2g9djrlhs6n" data-mpi={index}>
                <span className="text-sm font-bold text-white md:text-base" data-id="element-55" data-mp="26snktfj6qaxu">
                  Bono {index + 1} — {bonus.title}
                </span>
                <span className="shrink-0 text-base font-black text-red-500 line-through decoration-2 md:text-lg" data-id="element-56" data-mp="1e13xbjfk2aq1">
                  {bonus.price}
                </span>
              </li>)}
            <li className="flex items-center justify-between gap-4 border-t-2 border-white/20 py-5" data-id="element-57" data-mp="1n2twxcjlcfyw">
              <span className="text-lg font-black text-white md:text-xl" data-id="element-58" data-mp="1j0qicf1mkv9e">
                VALOR TOTAL
              </span>
              <span className="shrink-0 text-xl font-black text-red-500 line-through decoration-2 md:text-2xl" data-id="element-59" data-mp="2yg5tr3gxnybk">
                ARS {TOTAL_SAVINGS_ARS}
              </span>
            </li>
          </ul>

          <div className="border-t border-white/10 px-6 py-8 text-center md:px-10" data-id="element-60" data-mp="31y3eouiaxhu0">
            <p className="text-sm font-bold uppercase tracking-[0.18em] text-gray-400" data-id="element-61" data-mp="36zivubhcz474">
              Con tu compra de hoy
            </p>
            <p className="mt-2 text-4xl font-black text-[#22c55e] drop-shadow-[0_0_18px_rgba(34,197,94,0.65)] md:text-6xl" data-id="element-62" data-mp="2s3uz17eddjd9">
              TE LLEVÁS TODO POR $0 ARS
            </p>
            <button type="button" onClick={scrollToCompra} className="mt-6 w-full rounded-xl bg-[#22c55e] px-7 py-4 text-base font-black text-black transition-colors hover:bg-[#4ade80] focus:outline-none focus-visible:ring-4 focus-visible:ring-white md:w-auto" data-id="element-63" data-mp="3kqxrbhsgcxv2">
              QUIERO LOS 5 BONOS GRATIS
            </button>
          </div>
        </section>
      </div>
    </section>;
}